import React from "react";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const SecondaryColorButton = (props: PurposedButtonProps) => {
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="condition-button"
      buttonColor={colors.secondaryColor}
      {...props}
    />
  );
};

export default SecondaryColorButton;
